import { Button } from "@/components/ui/button";
import { useHasPermission } from "@/features/clients/hooks/use-permissions";
import type { ClientMessage } from "@/features/messages/types";
import { useTranslation } from "@/features/utils/i18n";
import { useState } from "react";
import { HandleMessageDialog } from "./handle-dialog";
import { MessageMenu } from "./message-menu";

export const Action = ({ message }: { message: ClientMessage }) => {
  const { t } = useTranslation("messages");
  const canManage = useHasPermission("messages:manage");
  const [handleOpen, setHandleOpen] = useState(false);

  return (
    <div className="flex items-center justify-end gap-2">
      {message.status === "pending" && canManage && (
        <Button size="sm" onClick={() => setHandleOpen(true)}>
          {t("actions.handle")}
        </Button>
      )}

      <MessageMenu message={message} />

      {handleOpen && (
        <HandleMessageDialog
          message={message}
          open={handleOpen}
          onOpenChange={setHandleOpen}
        />
      )}
    </div>
  );
};
